import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import Button from "../Button";
import { Row, Col, Pagination, Spin, Form } from "antd";
import { connect } from "react-redux";
import { getAdminUsersSwapHistory } from "../../redux/actions/adminPanel/adminUsersSwapHistory";
import { truncate } from "../../utils/truncateFunction";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { identity } from "../../utils/getIdentity";
import CopyWrapper from "../CopyWrapper";
import { getAdminUsersSwapList } from "../../redux/actions/adminPanel/adminUsersEmailsDownload";
import { InputSearch, RangePicker } from "../../adminPanel/components/FormFields";
import { notificationsErrorShow } from "../../redux/actions/notifications";
import { useDispatch } from "react-redux";
import { dateFormatterForRequest } from "../../adminPanel/components/UserTransactionsList/helpers";
import formatCurrency from "../../utils/currencyFormatter";

const UsersSwapHistory = ({ 
  getAdminUsersSwapHistory, 
  swapHistoryData, 
  swapHistoryFetching, 
  getAdminUsersSwapHistoryList, 
  totalOperations,
  totalUsdVolume,
}) => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState([undefined, undefined]);
  const [dateRangeTransformed, setDateRangeTransformed] = useState([undefined, undefined]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleRangeChange = (values) => {
    if (!values || values[0] === null || values[1] === null) {
      setDateRange([undefined, undefined]);
    } else {
      setDateRange(values);
    }
  };

  useEffect(() => {
    if (dateRange?.length && dateRange[0] && dateRange[1]) {
      const dates = dateFormatterForRequest({ dateRange: dateRange });
      setDateRangeTransformed(dates?.formattedDate);
    }
  }, [dateRange])

  useEffect(() => {
    if (dateRange?.length && dateRange[0] && dateRange[1]) {
      const dates = dateFormatterForRequest({ dateRange: dateRange });
      getAdminUsersSwapHistory({ search, page: 1, from: dates?.formattedDate[0], to: dates?.formattedDate[1] });
    } else {
      getAdminUsersSwapHistory({ search, page: 1, from: undefined, to: undefined });
    }
  }, [dateRange]);



  useEffect(() => {
    getAdminUsersSwapHistory();
  }, []);

  useEffect(() => {
    getAdminUsersSwapHistory({ search, page: currentPage, from: dateRange[0] ? dateRangeTransformed[0] : undefined, to: dateRange[1] ? dateRangeTransformed[1] : undefined });
  }, [currentPage]);

  const downloadFile = () => {
    if (!dateRange?.length || !dateRange[0] || !dateRange[1]) {
      dispatch(notificationsErrorShow({ message: "Please, choose date range" }));
    } else {
      getAdminUsersSwapHistoryList({ dateFrom: new Date(dateRange[0]), dateTo: new Date(dateRange[1]) })
    }
  }

  return (
    <div className="admin-swap">
      <div className="admin-swap__header">
        <div className="admin-swap__title">User`s Swap History</div>
        <div className="admin-swap__header--right">
          <Form form={form} initialValues={{ search: '' }}>
            <InputSearch
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onSearch={() => getAdminUsersSwapHistory({ search, page: 1, from: dateRange[0] ? new Date(dateRange[0]) : undefined, to: dateRange[1] ? new Date(dateRange[1]) : undefined })}
              onReset={() => {
                getAdminUsersSwapHistory({ search: '', page: 1, from: dateRange[0] ? new Date(dateRange[0]) : undefined, to: dateRange[1] ? new Date(dateRange[1]) : undefined })
                setSearch('');
                form.resetFields();
              }}
            />
          </Form>
          <RangePicker
            onChange={handleRangeChange}
            value={dateRange}
            clearAction={() => {
              setDateRange([undefined, undefined]);
              setDateRangeTransformed([undefined, undefined]);
            }}
          />
          <Button className="admin-swap__export" onClick={downloadFile}>Export</Button>
        </div>
      </div>

      <div className="admin-swap__body">
        {!swapHistoryFetching ? (
          <>
            {!!totalOperations && (
              <div>
                <span className="admin-swap__total">{t('admin.total_operations')}:</span> {totalOperations}
              </div>
            )}
            {!!totalUsdVolume && (
              <div className="admin-swap__total-volume">
                <span className="admin-swap__total">{t('admin.total_usd_volume')}:</span> {formatCurrency(totalUsdVolume)}
              </div>
            )}
            {swapHistoryData?.entities?.length ? (
              <Row className="admin-swap__body--title">
                <Col span={3}>Name</Col>
                <Col span={3}>Email</Col>
                <Col span={5}>Address From</Col>
                <Col span={5}>Address To</Col>
                <Col span={5}>Hash</Col>
                <Col span={3}>Date</Col>
              </Row>
            ) : <div className="admin-swap__body--empty">No swaps found</div>}
            <div className="admin-swap__body--list">
              {swapHistoryData?.entities?.length ? (
                swapHistoryData?.entities?.map((item) => {
                  return (
                    <Row className="admin-swap__body--row">
                      <Col className="admin-swap__body--wrap" span={3}>{item?.name || "-"}</Col>
                      <Col className="admin-swap__body--wrap" span={3}>{item?.email || "-"}</Col>
                      <Col span={5}>{item?.from?.address ?
                        <div>
                          <div className="admin-swap__body--flex"><span
                            className="admin-swap__body--bold">Address:</span> <CopyWrapper
                            copyContent={item?.from?.address}>{truncate(item?.from?.address, 14, "..")}</CopyWrapper>
                          </div>
                          <div><span
                            className="admin-swap__body--bold">Value:</span> {item?.from?.amount?.value}{" "}{item?.from?.currency?.title}
                          </div>
                          <div><span
                            className="admin-swap__body--bold">Value (usd):</span> {item?.from?.amount?.usd}$
                          </div>
                          <div><span
                            className="admin-swap__body--bold">Exhange id:</span> {item?.exchangeId || '-'}
                          </div>
                        </div>
                        : "-"}</Col>
                      <Col span={5}>{item?.to?.address ?
                        <div>
                          <div className="admin-swap__body--flex">
                            <span className="admin-swap__body--bold">Address:</span> <CopyWrapper
                            copyContent={item?.to?.address}>{truncate(item?.to?.address, 14, "..")}</CopyWrapper>
                          </div>
                          <div><span
                            className="admin-swap__body--bold">Value:</span> {item?.to?.amount?.value}{" "}{item?.to?.currency?.title}
                          </div>
                          <div><span
                            className="admin-swap__body--bold">Value (usd):</span> {item?.to?.amount?.usd}$
                          </div>
                        </div>
                        : "-"}</Col>
                      <Col span={5}>
                        <div className="admin-swap__body--flex"><span className="admin-swap__body--bold">From:</span> {item?.from?.hash && <CopyWrapper
                          copyContent={item?.from?.hash}>{truncate(item?.from?.hash, 14, "..")}</CopyWrapper>}</div>
                        <div className="admin-swap__body--flex"><span className="admin-swap__body--bold">To:</span> {item?.to?.hash && <CopyWrapper
                          copyContent={item?.to?.hash}>{truncate(item?.to?.hash, 14, "..")}</CopyWrapper>}</div>
                      </Col>
                      <Col span={3}>
                        {moment(item?.createdAt).format("D.MM.YYYY, HH:mm") || "-"}
                      </Col>
                    </Row>
                  );
                })
              ) : null}
            </div>

            <div className="activities__pagination">
              {swapHistoryData?.pages > 1 ? (
                <Pagination
                  current={+swapHistoryData?.page}
                  total={+swapHistoryData?.countItems}
                  pageSize={10}
                  showTotal={false}
                  showSizeChanger={false}
                  size="small"
                  onChange={page => setCurrentPage(page)}
                />
              ) : null}
            </div>
          </>
        ) : (
          <div className="admin-swap__body--loader">
            <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 16 }} spin />} />
          </div>
        )}
      </div>
    </div>
  )
};

const mapStateToProps = state => ({
  swapHistoryData: state.adminUsersSwapHistory.history.data,
  swapHistoryFetching: state.adminUsersSwapHistory.history.fetching,
  totalOperations: state.adminUsersSwapHistory.totalOperations,
  totalUsdVolume: state.adminUsersSwapHistory.totalUsdVolume,
});

const mapDispatchToProps = dispatch => ({
  getAdminUsersSwapHistory: getAdminUsersSwapHistory(dispatch),
  getAdminUsersSwapHistoryList: getAdminUsersSwapList(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersSwapHistory);